import { saveAs } from 'file-saver';
import { Accept } from 'react-dropzone';

/**
 * Convert file Buffer into Blob and download it.
 * @param {Blob} data File buffer.
 * @param {string} fileName Name of the downloaded file.
 */
export const downloadFile = (data: Blob, fileName: string) => {
  saveAs(data, fileName);
};

/**
 * Extract file extensions from Accept object.
 * @param {Accept} accept Accept object.
 * @returns {string} File extensions in upper case format.
 */
export const extractFileExtensions = (accept: Accept): string =>
  Object.values(accept)
    .flat()
    .map(type => type.slice(1).toUpperCase())
    .join(', ');
